// extracted by mini-css-extract-plugin
module.exports = {"sipView":"SipView_sipView__1X-j6","sipViewDefault":"SipView_sipViewDefault__2hMAG","fade":"SipView_fade__NMYLp"};